<template>
  <div class="content" id="home" :class="[`bg-${bg.type}`, `bg-${bg.id}`]"
    :style="{'background-image': `url(${bg.media.imageLg})`}"
    v-on:click="sectionClicked">
    <div class="loading" v-if="loading"></div>
    <div v-else class="homeCnt">
      <div class="homeItem" v-for="(item, i) in homeItem" :key="item.id">
        <div class="homeIcon iconBg" v-if="item.thumb && item.thumb[lang]"
          :style="{'background-image': `url(${item.thumb[lang]})`}"
          v-on:click.stop="openItem(item)">
          <div class="deleteItem" v-if="configOn"
            v-on:click.stop="deleteItem(i, item)"></div>
        </div>
        <div class="homeIcon" v-else :class="[item.type, item.code, {
          eventDir: item.type === 'directory' && item.directory && item.directory.isEventDir === 1,
        }]"
          v-on:click.stop="openItem(item)">
          <div class="deleteItem" v-if="configOn"
            v-on:click.stop="deleteItem(i, item)"></div>
        </div>
        <h4>{{item.name}}</h4>
      </div>
      <div class="homeAction">
        <button class="homeConfig" v-on:click.stop="configOn = !configOn"></button>
        <button class="changeBg" v-on:click="changeBg">Change Background</button>
      </div>
    </div>
    <BgSelector ref="bgSelector"/>
    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <MediaUploader ref="mediaUploader"/>
    <MediaInputer ref="mediaInputer"/>
    <LoadingDialog ref="loadingDialog"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BgSelector from '@/components/BgSelector.vue';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import MediaUploader from '@/components/MediaUploader.vue';
import MediaInputer from '@/components/MediaInputer.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';

export default {
  name: 'articles',
  components: {
    BgSelector,
    Confirmation,
    Snackbar,
    MediaUploader,
    MediaInputer,
    LoadingDialog,
  },
  data() {
    return {
      loading: false,
      homeItem: [],
      configOn: false,
      orgId: null,
      bg: {
        id: 0,
        type: 'fixed',
        media: {},
      },
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB', 'chDirId',
    ]),
    openItem(item) {
      if (item.type === 'dialog') {
        switch (item.code) {
          case 'upload_media':
            this.upload();
            break;
          case 'add_youtube':
            this.addYt();
            break;
          default:
            break;
        }
      } else if (item.uri) {
        this.$router.push(item.uri);
      }
    },
    sectionClicked() {
      this.configOn = false;
    },
    deleteItem(i, item) {
      this.$refs.confirmDialog.open({
        title: `Remove ${item.name}`,
        desc: 'Are you sure you want to remove this item from home?',
      }, (b) => {
        if (!b) return;
        this.homeItem.splice(i, 1);
        this.$http.get(this.$config.uri(`misc/home/${item.id}/delete`)).then(() => {
          this.$refs.snackbar.open({ content: `${item.name} removed from home` });
        });
      });
    },
    getHomeItem() {
      this.loading = true;
      this.$http.get(this.$config.uri('misc/home')).then((r) => {
        this.loading = false;
        this.homeItem = r.data.status === 200 ? r.data.data : [];
      });
    },
    validateYouTubeUrl(url) {
      if (!url || url === '') {
        return false;
      }
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/; //eslint-disable-line
      const match = url.match(regExp);
      const videoId = (match && match[2].length === 11) ? match[2] : false;
      return videoId;
    },
    addYt() {
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaInputer.open({
        title: 'Youtube Video Url',
        placeholder: 'Paste youtube video link here...',
        action: 'Insert Video',
      }, (b, uri) => {
        setTimeout(() => {
          document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        }, 200);
        if (!b) return;
        const videoId = this.validateYouTubeUrl(uri);
        if (!videoId) {
          this.$refs.confirmDialog.open({
            title: 'Invalid Video Url',
            desc: `The url for youtube video you input
              is not valid youtube url.`,
            error: true,
          }, () => {});
          return;
        }
        this.$refs.loadingDialog.open();
        this.$http.post(this.$config.uri('media/youtube/add'), { videoId }).then((r) => {
          this.$refs.loadingDialog.close();
          if (this.$route.path !== '/media/all') {
            this.$router.push('/media/all');
          } else {
            window.location.reload();
          }
        });
      });
    },
    upload() {
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaUploader.open(null, (b) => {
        setTimeout(() => {
          document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        }, 200);
        if (!b) return;
        if (this.$route.path !== '/media/all') {
          this.$router.push('/media/all');
        } else {
          window.location.reload();
        }
      });
    },
    getHomeConfig() {
      this.$http.get(this.$config.uri('misc/home/config')).then((r) => {
        const { data } = r.data;
        this.bg.id = data.bgId;
        this.bg.type = data.bgType;
        this.bg.media = data.media || {};
        const bgStr = JSON.stringify(this.bg);
        localStorage.setItem(`${this.$config.appId}_${this.orgId}_bg`, bgStr);
      });
    },
    saveHomeConfig() {
      this.$http.post(this.$config.uri('misc/home/config'), {
        bgId: this.bg.id,
        bgType: this.bg.type,
        mediaId: this.bg.media.id,
      }).then((r) => {});
    },
    changeBg() {
      this.$refs.bgSelector.open(this.bg, (b, v) => {
        if (!b) return;
        this.bg = v;
        this.saveHomeConfig();
        const bgStr = JSON.stringify(this.bg);
        localStorage.setItem(`${this.$config.appId}_${this.orgId}_bg`, bgStr);
      });
    },
  },
  mounted() {
    this.chCGB(false);
    this.chTitle('Home');
    this.chDirId(0);
    if (['event_manager', 'event_officer'].includes(this.$session.get(`${this.$config.appId}_role`))) {
      window.location.href = `${this.$config.appPath}event/overview`;
      return;
    }

    this.orgId = Number(this.$session.get(`${this.$config.appId}_org`));
    const bgStr = localStorage.getItem(`${this.$config.appId}_${this.orgId}_bg`);
    if (bgStr) {
      try {
        this.bg = JSON.parse(bgStr);
      } catch (err) {
        console.log(err.message); // eslint-disable-line
      }
    }
    this.getHomeConfig();
    this.getHomeItem();
  },
};
</script>


<style scoped lang="scss">
#home{
  background-color: #222;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
  width: auto;
  &.bg-fixed{
    &.bg-1{
      background-image: url(../assets/wallpaper/13756478_5309017.jpg) !important;
    }
    &.bg-2{
      background-image: url(../assets/wallpaper/13756478_5309014.jpg) !important;
    }
    &.bg-3{
      background-image: url(../assets/wallpaper/4264977_91352.jpg) !important;
    }
    &.bg-4{
      background-image: url(../assets/wallpaper/indonesia-flag-wrinkled.jpg) !important;
    }
    &.bg-5{
      background-image: url(../assets/wallpaper/dried-leaves-gray-blank.jpg) !important;
    }
    &.bg-6{
      background-image: url(../assets/wallpaper/satellite.jpg) !important;
    }
  }
  .homeCnt{
    display: flex;
    flex-wrap: wrap;
    padding: 50px 0;
    .homeAction{
      position: absolute;
      right: 30px; bottom: 30px;
      display: flex;
      .homeConfig{
        width: 40px; height: 40px;
        background-color: #fff;
        border: none;
        border-radius: 5px;
        transition: all .3s ease;
        cursor: pointer;
        background-image: url(../assets/settings.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 20px auto;
        &:hover{
          background-color: #f5f5fe;
        }
      }
      .changeBg{
        background-color: #fff;
        padding: 0 16px;
        margin-left: 10px;
        height: 40px;
        font-weight: 500;
        border-radius: 5px;
        font-size: 15px;
        border: none;
        transition: all .3s ease;
        cursor: pointer;
        line-height: 1;
        &:hover{
          background-color: #f5f5fe;
        }
      }
    }
    .homeItem{
      text-align: center;
      width: 120px;
      margin: 0 0 40px;
      padding: 0 10px;
      box-sizing: border-box;
      .homeIcon{
        background-color: #fff;
        width: 60px; height: 60px;
        border-radius: 10px;
        position: relative;
        margin: 0 auto 8px;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        }
        &.iconBg{
          background-size: cover;
        }
        .deleteItem{
          position: absolute;
          right: -6px; top: -6px;
          width: 20px; height: 20px;
          background-color: red;
          border-radius: 50%;
          background-image: url(../assets/close-white.png);
          background-size: 8px auto;
          background-position: center;
          background-repeat: no-repeat;
          cursor: pointer;
        }
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          background-size: 36px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .76;
        }
        &.menu_manager:before{
          background-image: url(../assets/menu-config.png);
        }
        &.page_editor:before{
          background-image: url(../assets/listing-black.png);
        }
        &.media_manager:before{
          background-image: url(../assets/image-black.png);
        }
        &.formSubmission:before{
          background-image: url(../assets/user3-black.png);
        }
        &.userAdmin:before{
          background-image: url(../assets/user-moderator-black.png);
        }
        &.add_youtube:before{
          background-image: url(../assets/youtube.png);
        }
        &.upload_media:before{
          background-image: url(../assets/upload-black.png);
        }
        &.web_config:before{
          background-image: url(../assets/cog.png);
        }
        &.content:before{
          background-image: url(../assets/draft-black.png);
        }
        &.user_admin:before{
          background-image: url(../assets/user-moderator-black.png);
        }
        &.form_submissions:before{
          background-image: url(../assets/user3-black.png);
        }
        &.all_content:before{
          background-image: url(../assets/directory.png);
        }
        &.directory{
          &:before{
            background-image: url(../assets/directory.png);
          }
          &.eventDir{
            &:after{
              content: "";
              position: absolute;
              right: 8px;
              bottom: 10px;
              background-color: #0e5dd2;
              border-radius: 50%;
              width: 12px;
              height: 12px;
              border: #fff 2px solid;
              opacity: 1;
              z-index: 3;
            }
          }
        }
      }
      h4{
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.loading{
  background-image: url(../assets/loading-4.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%; width: 100%;
  opacity: .36;
}
</style>
